// extracted by mini-css-extract-plugin
module.exports = {"nav-footer":"nav-footer_nav-footer__aN2sI"};